import { Geom } from '@/store/models/map';
import { Page } from '@/store/models/page';

export interface SimpleBlock {
  id: number;
  name: string;
  farm: number;
  crop: number;
}

export interface Block extends SimpleBlock {
  owner: number;
  ownerName: string;
  farm: number;
  farmName: string;
  crop: number;
  cropName: string;
  varietyName: string;
  sensor: number;
  area: number;
  entryDate: string;
  currentSensorLocation: string | null;
  currentSensor: string | null;
  nTrees: number | null;
  nRows: number | null;
  r2r: number | null;
  t2t: number | null;
  loRows: number | null;
}

export interface BlocksWithFruitCounts extends Block {
  fruitWeight?: number;
  avgDm: number;
  dmDate: string;
  // avgDm grown from dmDate to projectedTo at the block's rate (FMW-622)
  projectedDm?: number;
  projectedTo?: string;
  maturityDay: number;
  avgSample: number;
  dmPercentage?: number;
  dmTarget?: number;
  fruitsCount: number;
  dbFruitsCount?: number;
  fruitCountDate?: string;
  harvestCapacity: number;
  harvestCapacityThreshold: number;
  fieldBinSize: number;
  correctionFactor: number;
  packHouse: number | null;
  totalXCountAvg: number;
  totalYCountAvg: number;
  totalZCountAvg: number;
  grandTotalAvgCount: number;
  yieldPerTree: number;
  maximumFruitLoad: number;
  lAvg: number;
  wAvg: number;
  mAvg: number;
  huMaturityDate: string;
  method: string;
  cropK: number;
  startDate?: string;
  endDate?: string;
}

export interface BlocksWithSummary {
  id: number;
  name: string;
  farm: number;
  area: number;
  cropK: number;
  fruitWeight: number;
  fieldBinSize: number;
  totalFlowerCount: number;
  totalFruitCount: number;
}

export interface GeomBlock extends BlocksWithFruitCounts {
  polygonGeom: Geom | string;
  polygonLabel: Array<string | number>;
}

export interface PaginatedBlocks extends Page {
  results: Block[];
}
export interface CropType {
  id: number;
  name: string;
}

export interface CropVariety {
  id: number;
  name: string;
  cropType: number;
  cropTypeName: string;
}

export interface Crop {
  id: number;
  cropType: number;
  cropTypeName: string;
  name: string;
  variety: number;
  varietyName: string;
  targetHeatUnit: number;
  targetHeatUnitStoneHardening: number;
  maximumFruitLoad: number;
  yieldPerTree: number;
  heatBase: number;
  heatBaseUpper: number;
  k: number;
  weight: number;
  entryDate: string;
  endDay: number;
  endMonth: number;
  startDay: number;
  startMonth: number;
  harvestDateCalculationMethod: string;
  preferredGddMethod: string;
  harvestDaysOffset: number;
}

// Label per enum value of the two Crop method fields. The keys are the stored
// values, so the endpoint serves them with a plain JSON renderer and they stay
// snake_case here, unlike every other response.
export interface CropParameters {
  harvest_date_calculation_method: Record<string, string>;
  preferred_gdd_method: Record<string, string>;
}

export function emptyCropParameters(): CropParameters {
  return { harvest_date_calculation_method: {}, preferred_gdd_method: {} };
}

export interface AssignCrop {
  blocks: number[];
  crop: number;
}

export interface AssignCorrectionFactor {
  blocks: number[];
  correctionFactor: number;
}

export interface PackHouseBatchUpload {
  farm: number;
  season: number;
  csv: File | null;
}
